import service from "@/tools/request";
import defaultRequestErrorHandle from "@/plug/request/defaultErrorHandle";

export function sendSms({ phone }) {
  return service({
    url: '/sendSms',
    method: 'post',
    data: {
      phone
    }
  }).catch(defaultRequestErrorHandle)
}
export function checkCaptcha({ phone, code }) {
  return service({
    url: '/checkCaptcha',
    method: 'post',
    data: {
      phone, code
    }
  }).catch(defaultRequestErrorHandle)
}
export function bind({ name, idCard, phone, institution_id, kinship }) {
  return service({
    url: 'bind',
    method: 'post',
    data: {
      name, idCard, phone, institution_id, kinship
    }
  }).catch(defaultRequestErrorHandle)
}
// 外链

export function dockSendSms({ phone }) {
  return service({
    url: '/dock/sendSms',
    method: 'post',
    data: {
      phone
    }
  }).catch(defaultRequestErrorHandle)
}
export function dockCheckCaptcha({ phone, code }) {
  return service({
    url: '/dock/checkCaptcha',
    method: 'post',
    data: {
      phone, code
    }
  }).catch(defaultRequestErrorHandle)
}
export function sendCode({ phone }) {
  return service({
    url: "/sendCode",
    method: "post",
    data: {
      phone,
    },
  }).catch(defaultRequestErrorHandle);
}
export function checkSendCode({ phone, code }) {
  return service({
    url: "/checkSendCode",
    method: "post",
    data: {
      phone,
      code,
    },
  }).catch(defaultRequestErrorHandle);
}
export function logout({ phone }) {
  return service({
    url: '/logout',
    method: 'post',
    data: {
      phone
    }
  }).catch(defaultRequestErrorHandle)
}
export function sendCheckSms({ exam_id }) {
  return service({
    url: '/sendCheckSms',
    method: 'post',
    data: {
      exam_id
    }
  }).catch(defaultRequestErrorHandle)
}
  
export function checkCheckCode({ exam_id, code }) {
  return service({
    url: '/checkCheckCode',
    method: 'post',
    data: {
      exam_id,
      code
    }
  }).catch(defaultRequestErrorHandle)
}